var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"tab-list":_vm.tabList,"active-tab-key":_vm.currentTab},on:{"tabChange":_vm.tabChange}},[(_vm.currentTab == 'shelveTask')?_c('div',[_c('shelve-task-panel')],1):(_vm.currentTab == 'shelveRecord')?_c('div',[_c('shelve-record-panel')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }